{
	"title": "Crear declaración",
	"backLinkToMaterialDetailsTitle": "Volver a detalles de materiales",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Volver a {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Volver a Gestionar declaraciones",
	"steps": {
		"firstStep": {
			"title": "Paso 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Paso 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Paso 3",
			"label": "3"
		}
	}
}
